module.exports = __webpack_public_path__ + "static/media/course.38a397d7.svg";